<template>
  <Badge :class="badgeClass" variant="custom">
    {{ enumLabel }}
  </Badge>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { Badge } from '@/components/ui/badge';

const props = defineProps<{
  value: any;
  enumOptions: {
    label: string;
    value: string;
    class?: string;
  }[];
}>();

const enumLabel = computed(() => {
  return props.enumOptions.find(option => option.value === props.value)?.label;
});

const badgeClass = computed(() => {
  return props.enumOptions.find(option => option.value === props.value)?.class;
});
</script>
